import { MChatRiscoEnum } from 'graphql/types.generated'

import { RegistroMChatAcompanhamentoPuericultura } from '../../../aside/acompanhamento-puericultura/model'
import {
  ConsultaSeguimentoResultadoEnum,
  ConsultaSeguimentoViewModel,
} from './consulta-seguimento/model-consultaSeguimento'

export function isAccordionPreExpanded({
  ageInMonths,
  ageInMonthsAtendimentoAnterior,
  hasValuesAntendimentoAnterior,
  isMChatAnteriorRiscoBaixo,
}: {
  ageInMonths: number
  ageInMonthsAtendimentoAnterior: number
  hasValuesAntendimentoAnterior: boolean
  isMChatAnteriorRiscoBaixo: boolean
}) {
  if (ageInMonths >= 16 && !hasValuesAntendimentoAnterior) {
    return true
  }
  if (hasValuesAntendimentoAnterior && isMChatAnteriorRiscoBaixo) {
    return !(ageInMonths < 24 || ageInMonthsAtendimentoAnterior > 24)
  }
  return false
}

export function buildConsultaSeguimentoStats(
  item: RegistroMChatAcompanhamentoPuericultura
): ConsultaSeguimentoViewModel {
  const totalPerguntasRespondidas = new Set(
    item.aplicacao.map((p) => p.pergunta.match(/PERGUNTA_(\d+)_/)?.[1]).filter(Boolean)
  ).size

  const totalPerguntasFalhou = item.pontuacao

  const totalPerguntasPassou = totalPerguntasRespondidas - totalPerguntasFalhou

  const resultado =
    item.risco === MChatRiscoEnum.BAIXO
      ? ConsultaSeguimentoResultadoEnum.RASTREAMENTO_NEGATIVO
      : ConsultaSeguimentoResultadoEnum.RASTREAMENTO_POSITIVO

  return {
    totalPerguntasRespondidas,
    totalPerguntasFalhou,
    totalPerguntasPassou,
    resultado,
  }
}
